import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Ink from 'react-ink';
import ReactGA from 'react-ga';
import { CSSTransitionGroup } from 'react-transition-group';

import * as AppActions from '../app/AppActions';
import './Style';

class ThreeDModelContainer extends Component {
    constructor(props) {
      super(props)

      this.state = {
         iframeLoaded: false
      }

      this.threeDModelCloseClicked = this.threeDModelCloseClicked.bind(this);
    }

    componentDidMount() {
        // ReactGA.pageview(window.location.pathname);
    }

    threeDModelCloseClicked() {
        this.props.appActions.redirectToHome();
    }

    render() {
        const loaderBlock = !this.state.iframeLoaded
            ? <div className="loader"></div>
            : null;

        const url = window.innerWidth >= 768 ? this.props.url : `${this.props.url}&menuPosition=bottom`;

        return (
            <div>
                <CSSTransitionGroup
                    transitionName="opacityAnim"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <div className="threeDModel-container" key={'threeDModel'}>
                        <div className="threeDModel-header">
                            <h2>3d floor plan</h2>
                            <div className="threeDModel-close">
                                <button className="btn" onClick={this.threeDModelCloseClicked}>
                                    <i className="fa fa-times-circle"></i>
                                    <Ink />
                                </button>
                            </div>
                        </div>
                        {loaderBlock}
                        <div className="threeDModel-body">
                            <iframe
                                src={url}
                                sandbox="allow-forms allow-popups allow-same-origin allow-scripts"
                                frameBorder='0'
                                scrolling='yes'
                                onLoad={() => {this.setState({iframeLoaded: true})}}>
                            </iframe>
                        </div>
                    </div>
                </CSSTransitionGroup>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        url: state.threeDModel.url
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        appActions: bindActionCreators(AppActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThreeDModelContainer)
